import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
export default {
  data() {
    return {};
  },
  props: ['exhibitions', 'formData', 'language', 'special', 'childList'],
  //special 是否定制
  // childList 子级列表
  methods: {
    getType(type) {
      return type == '常设展览' ? 'permanent' : 'temporary';
    },
    showExhitonList(item) {
      let now = new Date();
      now = this.getDate(now);
      let flag = now >= this.getDate(item.exhibBegin) && now <= this.getDate(item.exhibEnd) || !item.exhibEnd || !item.exhibBegin;
      flag ? this.$router.push(`/${this.$route.query.fid == 152288 && this.childList.find(c => {
        return c.parentExhibitonName == item.exhibName;
      }) ? 'childExhibitions' : 'audios'}?fid=${this.formData.fid}&exhibCode=${item.code}${!this.language ? '&language=en' : ''}`) : alert('暂不在开放时间');
    },
    getDate(date) {
      return Date.parse(date);
    }
  },
  created() {},
  computed: {}
};